import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import { selectMeasureWeightsListItems } from "../../../../../../redux/measure-weights/selector";
import { measureWeights } from "../../../../../../redux/measure-weights/action";

const ManagementMeasureWeights = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
	const result = useSelector(selectCurrent)
	const { header, footer, currency } = result
  const [pageData, setPageData] = useState(1)
    const measureWeightsItems = useSelector(selectMeasureWeightsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Name', headerName: 'Name' },
          { field: 'SystemKeyword', headerName: 'System Keyword' },
          { field: 'Ratio', headerName: 'Ratio' },
          { field: 'IsPrimaryWeight', headerName: 'Primary Weight', cellRenderer: 'yesNoRenderer' },
          { field: 'DisplayOrder', headerName: 'Display Order' }
      
        ]);
      }
      const fetchMeasureWeights=()=>{

        dispatch(measureWeights.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/shipment/measure-weights/list`,entity:'measureWeights',jsonData:{
          "PageNumber": pageData,
             "PageSize": 10,
             "SortField": "Id",
             "SortOrder": "desc",}
         }));
       
      }
	useEffect(() => {
        createColumnDefs()
        fetchMeasureWeights()
	}, [pageData])

  const additionButtons: any = [
    {
      name: 'Add MeasureWeights',
      callback: () => handleAdd(),
    }
  ];
  const handleAdd=()=>{
    navigate(`/management/configuration/shipment/measure-weights/${0}`)
  }
  const handleEdit=(data: any)=>{
    navigate(`/management/configuration/shipment/measure-weights/${data?.Id}`)
  }
  const handleDelete=(data: any)=>{
    dispatch(measureWeights.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/shipment/measure-weights/delete`,
      entity: 'measureWeights',
      jsonData: {
          Records: [
              {
                  Id: data?.Id
              }
          ]
      }
  })).then(() => {
    dispatch(measureWeights.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/shipment/measure-weights/list`,entity:'measureWeights',jsonData:{
          "PageNumber": pageData,
             "PageSize": 10,
             "SortField": "Id",
             "SortOrder": "desc",}
         }));
  });
  } 
	return (
    <>
    {measureWeightsItems?.isLoading ? 
    <PageLoader />
:   
		<Table columnData={columnDefs} rowData={measureWeightsItems?.result?.items} setPageData={setPageData}
    paginationData={measureWeightsItems?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="Measure Weights" />
  }
  </> 
     
	);
};

export default ManagementMeasureWeights;


